<template><div>
  <h1 class="fdd-md--h1"></h1>
<h2 class="fdd-md--h2">Props</h2>
<h3 class="fdd-md--h3">item</h3>
<p class="fdd-md--p"><strong>Type:</strong> <code>String</code></p>
<p class="fdd-md--p"><strong>Default:</strong> <code>–</code></p>
<h3 class="fdd-md--h3">active</h3>
<p class="fdd-md--p"><strong>Type:</strong> <code>Boolean</code></p>
<p class="fdd-md--p"><strong>Default:</strong> <code>–</code></p>
<h2 class="fdd-md--h2">Slots</h2>
<h3 class="fdd-md--h3">default</h3>
<FdBadge filled>scoped</FdBadge>

  </div></template>
  <script>
  export default {
    mixins: [{
 data() {
  return {
    fddComponentApi: {"componentDesc":{"default":[]},"props":[{"name":"item","type":"String","describe":[],"required":true},{"name":"active","type":"Boolean","describe":[]}],"slots":[{"name":"default","describe":"","backerDesc":"","bindings":{},"scoped":true,"target":"script"}],"name":""}
  };
 }
}
]
  }
  </script>
  